/* ==========================================================================
   ASBEA STUDIOS — cookie consent + consent-gated analytics
   --------------------------------------------------------------------------
   Built on Shopify's Customer Privacy API, so a choice made here is the same
   choice Shopify itself honours for its own tracking and for Shopify pixels.

   The banner follows the Dutch DPA (Autoriteit Persoonsgegevens) norms:
     · refusing is one click, in the same place and with the same weight as
       accepting — never hidden behind an extra screen
     · every optional category starts switched OFF; the visitor opts in
     · nothing non-essential fires before a choice is made
     · consent can be withdrawn at any time from a link in the footer
   ========================================================================== */
(function () {
  'use strict';

  var CATEGORIES = ['preferences', 'analytics', 'marketing'];

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------------------------------------------------------------- API ---- */

  function withPrivacyApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !window.Shopify.customerPrivacy) return;
      cb(window.Shopify.customerPrivacy);
    });
  }

  function decided(api) {
    var c = api.currentVisitorConsent();
    // An empty string means "not answered yet" for that category.
    return CATEGORIES.some(function (k) { return c[k] === 'yes' || c[k] === 'no'; });
  }

  /* ------------------------------------------------------------- banner ---- */

  function initBanner() {
    var root = $('[data-cookie-banner]');
    if (!root) return;

    var layer1 = $('[data-cc-layer="1"]', root);
    var layer2 = $('[data-cc-layer="2"]', root);

    function open(layer) {
      root.hidden = false;
      root.classList.add('is-open');
      layer1.hidden = layer !== 1;
      layer2.hidden = layer !== 2;
    }

    function close() {
      root.classList.remove('is-open');
      window.setTimeout(function () { root.hidden = true; }, 350);
    }

    function apply(consent) {
      withPrivacyApi(function (api) {
        api.setTrackingConsent(
          {
            preferences: !!consent.preferences,
            analytics: !!consent.analytics,
            marketing: !!consent.marketing,
            // Sale/sharing of personal data follows the marketing choice.
            sale_of_data: !!consent.marketing
          },
          function () { close(); }
        );
      });
      // Fire immediately as well — the storefront event is authoritative, but
      // this keeps the page responsive if the API round-trip is slow.
      gate(consent);
    }

    function allTrue() { return { preferences: true, analytics: true, marketing: true }; }
    function allFalse() { return { preferences: false, analytics: false, marketing: false }; }

    function fromToggles() {
      var out = {};
      CATEGORIES.forEach(function (k) {
        var input = $('[data-cc-toggle="' + k + '"]', root);
        out[k] = !!(input && input.checked);
      });
      return out;
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cc]');
      if (!btn) return;
      var action = btn.dataset.cc;
      if (action === 'accept') apply(allTrue());
      else if (action === 'reject') apply(allFalse());
      else if (action === 'save') apply(fromToggles());
      else if (action === 'open-settings') open(2);
    });

    // Footer link — withdrawing must be as easy as giving.
    $$('[data-cookie-settings]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        withPrivacyApi(function (api) {
          var c = api.currentVisitorConsent();
          CATEGORIES.forEach(function (k) {
            var input = $('[data-cc-toggle="' + k + '"]', root);
            if (input) input.checked = c[k] === 'yes';
          });
          open(2);
        });
      });
    });

    withPrivacyApi(function (api) {
      // shouldShowBanner() is true only where consent is legally required.
      var required = typeof api.shouldShowBanner === 'function' ? api.shouldShowBanner() : true;
      if (required && !decided(api)) open(1);
      gate(readConsent(api));
    });
  }

  function readConsent(api) {
    var c = api.currentVisitorConsent();
    return {
      preferences: c.preferences === 'yes',
      analytics: c.analytics === 'yes',
      marketing: c.marketing === 'yes'
    };
  }

  /* ------------------------------------------------- consent-gated tags ---- */

  var loaded = { ga4: false, meta: false };

  function loadGa4(id) {
    if (loaded.ga4 || !id) return;
    loaded.ga4 = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    // No cookie is written until this call, and IP anonymisation stays on.
    window.gtag('config', id, { anonymize_ip: true });
  }

  function loadMeta(id) {
    if (loaded.meta || !id) return;
    loaded.meta = true;
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  }

  function gate(consent) {
    var cfg = window.ASBEA_TAGS || {};
    if (consent.analytics) loadGa4(cfg.ga4);
    if (consent.marketing) loadMeta(cfg.meta);
  }

  // Shopify republishes the decision here — including changes made elsewhere.
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = e.detail || {};
    gate({
      preferences: !!d.preferencesAllowed,
      analytics: !!d.analyticsAllowed,
      marketing: !!d.marketingAllowed
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBanner);
  } else {
    initBanner();
  }
})();
